<div class="platform-horizontal-navigation-wrapper">

    <ng-container *ngFor="let item of navigation; trackBy: trackByFn">

        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <ng-container *ngIf="item.type === 'basic'">
                <platform-horizontal-navigation-basic-item
                    class="platform-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></platform-horizontal-navigation-basic-item>
            </ng-container>

            <!-- Branch: aside, collapsable, group -->
            <ng-container *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'">
                <platform-horizontal-navigation-branch-item
                    class="platform-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></platform-horizontal-navigation-branch-item>
            </ng-container>

            <!-- Spacer -->
            <ng-container *ngIf="item.type === 'spacer'">
                <platform-horizontal-navigation-spacer-item
                    class="platform-horizontal-navigation-menu-item"
                    [item]="item"
                    [name]="name"></platform-horizontal-navigation-spacer-item>
            </ng-container>

        </ng-container>

    </ng-container>

</div>
